module.exports = __webpack_public_path__ + "img/explosive.timed.3c6e1f8c.png";